module.exports = __webpack_public_path__ + "static/media/others.42bc2a5f.png";